import {ProfileEmployment} from './profileEmployment';

export const Employment = ProfileEmployment;
